import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { userData } from "../../common/GetUserData";

export const Private = () => {
  const isAuth = userData;

  if (isAuth) {
    return <Outlet />;
  } else {
    sessionStorage.clear();
    return <Navigate to={"/"} />;
  }
};

export const Public = () => {
  const isAuth = userData;
  if (isAuth) {
    sessionStorage.clear();
    window.location.replace("/");
  }
  return <Outlet />;
};

export const RequireAuth = ({ allowedRoles }) => {
  const userData = userData;
  const Role = userData.UROLEID;
  const location = useLocation();

  const content = allowedRoles.includes(Role) ? (
    <Outlet />
  ) : (
    <>
      {window.location.replace("/")}
      <Navigate to="/" state={{ from: location }} replace />
    </>
  );

  return content;
};

// export const Public = () => {
//   const isAuth = localStorage.getItem("isAuth");
//   if (!isAuth) {
//       return <Outlet />;
//   }
//   return <Navigate to={"/homepage"} />;
// };
